import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* The sidebar's Members icon. */}
    <g transform="translate(3 1)">
      <circle cx="9" cy="5" r="4" />
      <path d="M1 16C1 14.3431 2.34315 13 4 13H14C15.6569 13 17 14.3431 17 16V20H1L1 16Z" />
    </g>
  </ContentTile>
);
